// @flow
import React, { type Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';
import Button from '@rover/react-lib/components/buttons/Button';

type Props = {
  isComplete: boolean,
  buttonText: string,
  saveMethod: () => void,
  wantingToEdit: Object,
  disabled: boolean,
};

const SaveButtonWrapper: StyledComponent<{}> = styled.div`
  text-align: center;
`;

const SectionSaveButton = ({
  isComplete,
  buttonText,
  saveMethod,
  wantingToEdit,
  disabled,
}: Props): Node => (
  <div>
    {!isComplete || Object.values(wantingToEdit).some(currentlyEditing => currentlyEditing) ? (
      <SaveButtonWrapper>
        <Button disabled={disabled} marginBottom="8x" onClick={saveMethod}>
          {buttonText}
        </Button>
      </SaveButtonWrapper>
    ) : (
      <div />
    )}
  </div>
);

SectionSaveButton.defaultProps = {
  wantingToEdit: {},
  disabled: false,
};

export default SectionSaveButton;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/components/common/SectionSaveButton.jsx